import model from "../model";
import sendServerRequest from "../services/send-server-request";
import type { MaintenanceClientConfig } from "../types/client-config-types";
import { addQueryParams, minsToMills } from "../utils/utils";
import { getLangText } from "@/ts/utils/model-utils";
import { showNotification } from "./notifications-management";
import { clearUserSession } from "./user-management";

type MaintenanceData = {
	msgFrom: string,
	offline: {
		dateFrom: string,
		dateTo: string
	},
};

const TIMEOUT_MINS_OFF = 5;
const TIMEOUT_MINS_ACTIVE = .5;

let timeout = 0;
let refreshTime = 0;

let maintenanceConfig: MaintenanceClientConfig | undefined;

export default {
    init() {
		maintenanceConfig = model.clientConfig.maintenance;
        if(!maintenanceConfig?.active || typeof maintenanceConfig?.config !== 'string') return;
		sendReq();
    },
}

function sendReqTimeout(mins: number){
	refreshTime = minsToMills(mins);

	clearTimeout(timeout);
	timeout = setTimeout(sendReq, refreshTime);
}

async function sendReq(){
	if(!maintenanceConfig?.config) return;

	const url = addQueryParams(maintenanceConfig.config, {
		'_': Date.now() + '',
	});

    const configResp = await sendServerRequest(url, undefined);
	if(!configResp) {
		sendReqTimeout(TIMEOUT_MINS_OFF);
		return;
	}

	const data = (await configResp.json()) as MaintenanceData;
	if(!data) {
		sendReqTimeout(TIMEOUT_MINS_OFF);
		return;
	}
	
	let msgFrom = new Date(data.msgFrom);
	let offline = {
		dateFrom: new Date(data.offline.dateFrom),
		dateTo: new Date(data.offline.dateTo),
	};

	if(isNaN(msgFrom.getTime()) || isNaN(offline.dateFrom.getTime()) || isNaN(offline.dateTo.getTime())){
		console.warn("One of the maintenance-related dates is incorrectly formatted. ");
		sendReqTimeout(TIMEOUT_MINS_OFF);
		return;
	}

	let now = Date.now();

	if(offline.dateTo.getTime() < now) {
		sessionStorage.removeItem('maintenance-notified');
		sendReqTimeout(TIMEOUT_MINS_OFF);
		return;
	}

	if(offline.dateFrom.getTime() < now && offline.dateTo.getTime() > now){
		clearUserSession();
		sessionStorage.removeItem('maintenance-notified');
		window.location.replace(addQueryParams(maintenanceConfig.path, {
			offlineUntil: data.offline.dateTo,
			lang: model.lang,
		}));
		return;
	}

	if(msgFrom.getTime() < now){
		sendReqTimeout(TIMEOUT_MINS_ACTIVE);

		if(sessionStorage.getItem('maintenance-notified') !== 'true'){
			let dateFrom = new Date(offline.dateFrom).toLocaleString();
			let dateTo = new Date(offline.dateTo).toLocaleString();
	
			showNotification({
				title: getLangText('MaintenanceTitle'),
				text: getLangText('MaintenanceText')?.replace('{dateFrom}', `<b>${dateFrom}</b>`).replace('{dateTo}', `<b>${dateTo}</b>`),
				first: true,
				closeDisabled: true,
				afterTerminate: () => sessionStorage.setItem('maintenance-notified', 'true'),
			});
		}

		return;
	}

	sendReqTimeout(TIMEOUT_MINS_OFF);
}